<template>
    <div class="Fomsnrk"> 
        <div class=" mb-2 lislet FomsMode" ref="scrollContainer">
            <div v-for="(data,i) in FomsMode" :key="data.value" class="foms mb-2">
                <el-date-picker 
                            v-model="data.date"
                            :disabled="disabled"
                            type="date" 
                            class="w-1p mr-1 w-20 tiem"
                            value-format="timestamp"
                            :picker-options="forbiddenStartTime"
                            placeholder="选择日期"/>
                <div class="left">
                    <div v-for="(item,index) in data.offer_info"  :key="index" >
                        <div class="text-left mb-3 pl" >
                            <el-select :disabled="disabled" v-model="item.type" placeholder="请选择类型" class="w-15 mr-2 mr-49 pl-2 " >
                                <el-option
                                v-for=" i in $GVAR.roomStyle"
                                :key="i.id"
                                :label="i.name"
                                :value="i.id">
                                </el-option>
                            </el-select>
                            <el-input type="number"  v-model.number="item.room_num" @mousewheel.native.prevent class="w-16" placeholder="间数">
                                <span slot="append">间</span>
                            </el-input>
                            <!-- <el-input type="number" v-model.number="item.night_num" @mousewheel.native.prevent class="w-16 pl-2"  >
                            <span slot="append">晚</span>
                            </el-input> -->
                            <el-select class="w-20 mr-3 mr-49 pl-2" 
                                        :value="item.offer_title"
                                        @change="getId($event,i,index)"
                                        @blur="blurs($event,i,index)"
                                        :filterable="true"
                                        allow-create
                                        default-first-option
                                        placeholder="请选择或输入房型"
                                        :disabled="disabled"
                                        >
                            <template v-for="roomItem in StoreRoomArr.meetArr"  >
                                <el-option 
                            
                                        v-if="item.type<=3?item.type==roomItem.type:true"
                                        :key="roomItem.title"
                                        :label="roomItem.title"
                                        :value="`${roomItem.id},${roomItem.title}`">
                                </el-option>
                            </template>
                            </el-select>
                            <p class="pl-2" >单价</p>
                            <el-input placeholder="金额" class="w-28 mr-2 price" type="number" 
                                    v-model.number="item.offer_price">
                                <span slot="prepend">&yen;</span>
                                <span slot="append" class="lisxn">元/晚</span>
                            </el-input>
                            <i class="el-icon-close close" v-if="!disabled" @click="splicse(i,index)"></i>
                        </div>
                    </div>
                    <div class=" el-checkbox-group d-center-start form-widtht mb-3" v-if="!disabled">
                        <i class="el-icon-circle-plus nis" @click="addMeeting(i)"></i>
                        添加新的房型
                    </div>
                </div>
            </div>
        </div>
       <div  v-if="!disabled" @click="submitPost" class="ls leftText blieDne mb-3" >增加日期</div>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
export default {
    computed: {
      ...mapState(['orderPostPre','DisplayBasicInfo','StoreLists','OrderDetail','StoreRoomArr','StoreMeetArr']),
      ...mapGetters(['storeInfo','isGroup']),
    },
    props:{
        priceArr:'',
        need_mode:'',
        room_need_arr:'',
        timestamp:'',
        totalNum:'',
        disabled:'',
    },
    mounted() {
        if(this.need_mode==1){ 
           let FomsMode=JSON.parse(JSON.stringify(this.room_need_arr))
           for(let i in FomsMode){
               FomsMode[i].date=FomsMode[i].date*1000;
            }   
            this.FomsMode=FomsMode;
            return
        } 
        let name=this.priceArr.filter(todo=>todo.shos==1);
        name=name.map(item=>{
            let data={
                offer_title:item.offer_title,
                type:item.type,
                room_num:item.room_num,
                offer_id:item.offer_id,
                offer_price:item.offer_price,
                label:item.label
            }
            return data
        })
        for(let i=0; i<this.totalNum*1; i++){
            let data={
                date:this.timestamp[0]+86400*i*1000,
                offer_info:[
                ...name
                ]
            }
            if(data.offer_info.length==0){
                data.offer_info.push(this.meetObjfs.offer_info)
            }
            this.FomsMode.push(JSON.parse(JSON.stringify(data)));
        }
    },
    data() {
        return {
            FomsMode:[],
            meetObjfs:{
                date:'',
                offer_info:[
                    { type:'',room_num:'',offer_price:'',offer_id:'',offer_title:''},
                ]
            },
            //禁用选中日期
            forbiddenStartTime:{ 
                disabledDate: this.disabledDateMethod,
            },
        }
    },
    watch:{
        FomsMode: {
            deep: true,      //深度监听
            // immediate: true, //初始化时让handler调用一下
            //handler什么时候调用？当mane发送改变时
            handler(newvalue, oldvalue) {
                let sortedData =this.$options.filters['sortByTime'](newvalue,'date');//重新按时间排序
                this.scrollToBottom();
                this.$emit('datePrompt',sortedData)
            }
        },
    },
    methods: {
        getId(val,i,index,p){
        console.log(val.length);
            let [id, name] = val.split(',');
            let n=this.FomsMode[i].offer_info;
            let room_offer={
                ...n[index],
                offer_id:name?id:'0',
                offer_title:name?name:id
            }
            this.$set(n,index,room_offer);
        },
        blurs(val,i,index,p){
            let n=this.FomsMode[i].offer_info;
            if(val.target.value){
                let room_offer={
                    ...n[index],
                    offer_id:'0',
                    offer_title:val.target.value
                }
                this.$set(n,index,room_offer)
            }
        },
        //不可以重复选中日期
        disabledDateMethod(time) {
            let  hasTarget = this.FomsMode.some(user => user.date === time.getTime());
            // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
            return hasTarget
        },
        //添加新的房型
        addMeeting(i){
            let data = Object.assign({}, JSON.parse(JSON.stringify(this.meetObjfs.offer_info[0])));
            this.FomsMode[i].offer_info.push(data);
        },
        //删除房型
        splicse(i,index){
            if( this.FomsMode[i].offer_info.length==1){
                this.FomsMode.splice(i,1)
            }else{
                this.FomsMode[i].offer_info.splice(index,1)
            }
        },
        submitPost(){
            let data = Object.assign({}, JSON.parse(JSON.stringify(this.meetObjfs)));
            this.FomsMode.push(data);
            setTimeout(() => {this.scrollToBottom();},500);
        },
        //平滑滚动到底部
        scrollToBottom() {
            const container = this.$refs.scrollContainer;
            console.log(container);
            if (container) {
                let scrollHeight=container.scrollHeight;
                container.scrollTo({
                    top: scrollHeight,
                    behavior: 'smooth'
                });
            }
        }
    },
    }
</script>

<style scoped>
.hlis{
    height: 60px;
}
.FomsMode{
    width: 1000px !important;
    max-height: 460px;
    overflow: auto;
    border-bottom: 1px #eee solid;
}
.FomsMode .left {
    width: 79%;
    float: left;
}
.FomsMode .tiem{
    float: left;
}
.FomsMode .foms{
    border-bottom: 1px #eee solid;
    padding-top: 16px;
    overflow: hidden;
}
.FomsMode .foms:nth-child(1){
    margin-top: -16px;
}
.FomsMode .foms:last-child {
  border-bottom: none;
}
.botleLq{
    margin-left: 0;
    float: inline-start;
}
.leftText{
    float: left;
    margin-left: 130px;
}
.Fomsnrk{
    overflow: hidden;
}
</style>